import {useRef, useState} from 'react'
import './Authorization.scss'
import '../Loader.scss'
import axios from 'axios'
import { toast } from 'react-toastify';
import 'react-phone-number-input/style.css'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import img_checked from '../../assets/checked.png'
import wa_icon from '../../assets/icons/Whatsapp-icon.svg'
import { useParams } from 'react-router-dom';


function Authorization() {
    const [userPhoneNumber, setPhone] = useState('');
    const [userCode, setCode] = useState('');
    const [status, setStatus] = useState('');

    const phoneInput = useRef(null);
    const codeInput = useRef(null);

    const [userName, setUserName] = useState('');
    const [userEmail, setUserEmail] = useState('');

    const [isAwaitingResponse, setAwaitingResponse] = useState(false)

    const api = process.env.REACT_APP_API_URL;

    const { product } = useParams();

    const sendCode = async (event) => {
        event.preventDefault();
        setAwaitingResponse(true);
        
        if(userPhoneNumber === undefined || !isValidPhoneNumber(userPhoneNumber)){
            toast.error("Invalid phone number. Please make sure you've entered your data correctly and try again.");
            setAwaitingResponse(false);
            return;
        }

        event.target.disabled = true;
        phoneInput.current.disabled = true;
        
        const data = {
            user_phone: formatPhoneNumber(userPhoneNumber),
            user_email: userEmail,
            user_name: userName,
            user_timezone: getTimezone(),
            program: product
        }

        axios.post(`${api}/user/verification/request`, data)
            .then((response) => {
                const resStatus = response.data.status;
                setStatus(resStatus);
                if(resStatus === 'awaiting'){
                    toast.success("Verification code is on it's way! Open your WhatsApp app.");
                }
                else if (resStatus === 'verified'){
                    toast.success("This phone number was already verified!")
                }
            })
            .catch((error) => {
                console.error("Error:", error);
                toast.error("Network error. Please try again.");
                phoneInput.current.disabled = false;
            })
            .finally(() => {
                setAwaitingResponse(false);
                event.target.disabled = false;
            });
    }

    const confirmCode = async (e) => {
        e.target.disabled = true;
        codeInput.current.disabled = true;
        setAwaitingResponse(true);

        const data = {
            user_phone: formatPhoneNumber(userPhoneNumber),
            code: userCode,
            program: product
        }

        axios.post(`${api}/user/verification/confirm`, data)
            .then((response) => {
                const resStatus = response.data.status;
                setStatus(resStatus);
                if(response.data.message) {
                    toast.error(response.data.message);
                }
                if(resStatus === "invalid_code") return;
                toast.success("Verified successfully!");
            })
            .catch((error) => {
                console.error("Error:", error);
                toast.error("Network error. Please try again.");
            })
            .finally(() => {
                setAwaitingResponse(false);
                e.target.disabled = false;
                codeInput.current.disabled = false;
            });
    }

    const handleCodeChange = (e) => {
        setCode(e.target.value);
    }

    const formatPhoneNumber = (phoneNumber) => {
        let result = phoneNumber.replace("+","");
        return result;
    }

    const getTimezone = () => {
        let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        
        timezone = timezone === "Europe/Kiev" ? "Europe/Kyiv" : timezone;

        return timezone;
    }

    const getWALink = (program) => {
        let botPhoneNumber = "";
        switch (program) {
            case "stop-smoking":
                botPhoneNumber = process.env.REACT_APP_WA_CHATBOT_NUMBER_SS;
                break;
            case "peak-performance":
                botPhoneNumber = process.env.REACT_APP_WA_CHATBOT_NUMBER_PP;
                break;
            case "healthy-diet":
                botPhoneNumber = process.env.REACT_APP_WA_CHATBOT_NUMBER_WL;
                break;
            case "stressful-talks":
                botPhoneNumber = process.env.REACT_APP_WA_CHATBOT_NUMBER_ST;
                break;
            default:
                break;
        }

        return "https://wa.me/" + botPhoneNumber;
    }

    return (
        <div className="registration form">
            {
                isAwaitingResponse ? (
                    <div className='loader bg'>
                        <div className='loader spinner'></div>
                    </div>
                ) : <></>
            }
            {status === ""
                ? (
                    <>
                    <header>
                        <h3 className='title'>Register for a free trial!</h3>
                    </header>
                    <main>
                        <form className="inputs" onSubmit={sendCode}>
                            <div className='name email input-group multiple gap'>
                                <input 
                                    type='text' 
                                    className='input'
                                    id='user_name' 
                                    required 
                                    placeholder='Name' 
                                    onChange={(e) => setUserName(e.target.value)}
                                />
                                <input
                                    type='email' 
                                    className='input'
                                    id='user_email' 
                                    required 
                                    placeholder='Email' 
                                    onChange={(e) => setUserEmail(e.target.value)}
                                />
                            </div>
                            <div className="phone input-group icon gap">
                                <img alt=""  className='icon' src={wa_icon}/>
                                <PhoneInput
                                    ref={phoneInput}
                                    placeholder="Enter phone number"
                                    value={userPhoneNumber}
                                    onChange={setPhone}
                                    id="userPhoneNumber"/>
                            </div>
                            <button className='btn primary submit'>Submit</button>
                        </form>
                    </main>
                    </>
                )
                : status !== "verified" && status !== "done" ?
                (
                    <>
                    <header>
                        <h3 className='title'>Please verify your phone number</h3>
                    </header>
                    <main>
                        <form className='inputs'>
                            <div className="confirmation input-group multiple gap">
                                <label htmlFor="userConfirmation">Confirmation Code:</label>
                                <div className='input-group icon gap'>
                                    <img alt=""  className='icon' src={wa_icon}/>
                                    <input 
                                        type="text"
                                        className='input'
                                        ref={codeInput} 
                                        name="userConfirmation" 
                                        id="userConfirmation" 
                                        placeholder='000000' 
                                        value={userCode} 
                                        onChange={handleCodeChange} 
                                        autoComplete='off'
                                    />
                                </div>
                            </div>
                            <button className='btn primary submit' onClick={confirmCode}>Submit</button>
                        </form>
                    </main>
                    </>
                )
                :
                (
                    <>
                    <header>
                        <h3 className='title'>You're all set!</h3>
                    </header>
                    <main>
                        <div className='inputs'>
                            <img alt=""  className='confirmed' src={img_checked}></img>
                            <p>All done! Click the button bellow and say "Hi" to the chatbot to start your journey.</p>
                            <a className='btn primary submit' href={getWALink(product)} target='_blank' rel="noreferrer noopener">Go to WhatsApp</a>
                        </div>
                    </main>
                    </>
                )
            }
        </div>
    )
}

export default Authorization